export default __webpack_public_path__ + "static/pole-1-img-843eee17e58f653c8d5a548b10dcb749.png";